import { useEffect, useState } from "react";
import "./MainPageStyle.css"
import { emEmergency } from "../model/emEmergency";
import { AiFillEdit,AiFillDelete} from "react-icons/ai";
import { IoMdMail } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Popup from "./CondPopUp";

interface Props{
    loggedState: number;
    setLoggedState: React.Dispatch<React.SetStateAction<number>>;
    loggedName: String;
    setLoggedName: React.Dispatch<React.SetStateAction<String>>;
    loggedID: String;
    setLoggedID: React.Dispatch<React.SetStateAction<String>>;
    agbStatus: number;
    dsgvoStatus: number;
    useCondStatus: number;
}

function MainPage({loggedState,setLoggedState,loggedName,setLoggedName,loggedID,setLoggedID,dsgvoStatus,agbStatus,useCondStatus}:Props){
    const [einsaetze, setEinsaetze] = useState<emEmergency[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>(""); 
    const [showPopUp, setShowPopup] = useState(false);
    const navigate = useNavigate();
  
    useEffect(() => {
      ReadEmergency(-1,loggedID);
      if (agbStatus !== 1 || dsgvoStatus !== 1 || useCondStatus !== 1) {
        setShowPopup(true);
      }
    }, [agbStatus, dsgvoStatus, useCondStatus]);


      const ReadEmergency = async (emID:number,loggedID:String) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadEmergency.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              emID,
              loggedID,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            setEinsaetze(data);
          } else {
            const data = await response.json();
            console.error('Fehler beim lesen des Einsatz:', response.statusText);
          }
        } catch (error) {
          console.error('Fehler beim Request:', error);
        }
    };

    const logout = () => {
        setLoggedState(0);
        setLoggedName("");
        setLoggedID("");
        navigate("/");
    };

    const filteredEmergency = einsaetze.filter(em => 
      em.description.toLowerCase().includes(searchTerm.toLowerCase()) // Filter nach Name
    );

    const settMember = () => {
        navigate("/Member");
    };

    const settCars = () => {
        navigate("/Cars");
    };

    const settSuits = () => {
        navigate("/Suits");
    };

    const settSettings = () => {
      navigate("/Settings");
  };

    const AddEmergency = () => {
        navigate("/AddEmergency");
    };

    const editEM = (id:number) => {
        navigate("/AddEmergency",{ state: { id: id } });
    };

    const deleteEM = (id:number) => {
        const deleteEmergency = async (emID:number) => {
            try {
                const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteEmergency.php', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    emID,
                  }),
                });
          
                if (response.ok) {
                  const data = await response.json();
                  // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
                  if(data.status === 'success'){
                    alert("Einsatz wurde gelöscht");
                    ReadEmergency(-1,loggedID);
                  }
                  else{
                    alert("Einsatz konnte gelöscht werden werden");
                  }
                    
                } else {
                  const data = await response.json();
                  console.error('Fehler beim lesen des Einsatz:', response.statusText);
                  alert("Einsatz konnte nicht aktualisiert werden");
                }
              } catch (error) {
                console.error('Fehler beim Request:', error);
              }   
        
        };
        const userResponse = window.confirm('Wollen Sie den Einsatz wirklich löschen?');
        if (userResponse) { //yes
            deleteEmergency(id);
        } else {
            //no
        }
    };

    const mailEM = (emID:number,loginID:String,organisationName:String) => {
        const sendMail = async (emID:number) => {
            try {
                const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/SendMail.php', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    emID,
                    loginID,
                    organisationName
                  }),
                });
          
                if (response.ok) {
                  const data = await response.json();
                  if(data.message === 'Mail gesendet'){
                    alert("Mail wurde gesendet");
                  }
                  else{
                    alert("Mail konnte nicht gesendet werden");
                  }
                } else {
                  const data = await response.json();
                  console.error('Fehler beim lesen des Einsatz:', response.statusText);
                  alert("Mail konnte nicht gesendet werden");
                }
              } catch (error) {
                console.error('Fehler beim Request:', error);
              }   
        
        };
        sendMail(emID);
    };
  
    return (
  <div className="MainStyle_container" style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}>
    {showPopUp && (
      <Popup
        tag={loggedID}
        agbStatus={agbStatus}
        dsgvoStatus={dsgvoStatus}
        useCondStatus={useCondStatus}
      />
    )}

    <div className="MainStyle_header">
      <div className="MainStyle_header-settings">
        <button className="MainStyle_settings-button" onClick={() => settMember()}>Einsatzkräfte</button>
        <button className="MainStyle_settings-button" onClick={() => settCars()}>Fahrzeuge</button>
        <button className="MainStyle_settings-button" onClick={() => settSuits()}>Einsatzkleidung</button>
        <button className="MainStyle_settings-button" onClick={() => settSettings()}>Einstellungen</button>
      </div>

      <div className="MainStyle_header-logout">
        <button className="MainStyle_logout-button" onClick={() => logout()}>Abmelden</button>
      </div>
    </div>

    <div className="MainStyle_search-box-container">
      <div className="MainStyle_header">
        <h2>Einsatzmanagement {loggedName}</h2>
        <button className="MainStyle_new-button" onClick={() => AddEmergency()}>Neuer Einsatz</button>
      </div>
      <div className="MainStyle_search-box">
        <label htmlFor="search">Suche:</label>
        <input 
          type="text" 
          id="search"  
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>

    <ul>
      <li className="MainStyle_table-header">
        <div className="MainStyle_col MainStyle_col-1">Nr</div>
        <div className="MainStyle_col MainStyle_col-2">Datum</div>
        <div className="MainStyle_col MainStyle_col-3">Anlass</div>
        <div className="MainStyle_col MainStyle_col-4">Beschreibung</div>
        <div className="MainStyle_col MainStyle_col-5">Ort</div>
        <div className="MainStyle_col MainStyle_col-6">Aktion</div>
      </li>
      {filteredEmergency.map((einsatz) => (
      <li className="MainStyle_table-row" key={einsatz.ID}>
        <div className="MainStyle_col MainStyle_col-1" data-label="Nr">{einsatz.einsatzNr}</div>
        <div className="MainStyle_col MainStyle_col-2" data-label="Date">{einsatz.date}</div>
        <div className="MainStyle_col MainStyle_col-3" data-label="Reason">{getReasonText(einsatz.reason)}</div>
        <div className="MainStyle_col MainStyle_col-4" data-label="Description">{einsatz.description}</div>
        <div className="MainStyle_col MainStyle_col-5" data-label="Place">{einsatz.place}</div>
        <div className="MainStyle_col MainStyle_col-6" data-label="Action">
            <span className='MainStyle_icon' onClick={()=> editEM(einsatz.ID)}>
                <AiFillEdit />
            </span>
            <span className='MainStyle_icon' onClick={()=> deleteEM(einsatz.ID)}>
                <AiFillDelete />
            </span>
            <span className='MainStyle_icon' onClick={()=> mailEM(einsatz.ID,loggedID,loggedName)}>
                <IoMdMail />
            </span>
        </div>
      </li>
      ))}
    </ul>
  </div>
);


  };
  
  const getReasonText = (reasonNumber:number) => {
    // Hier könntest du eine umfassendere Logik für die Entsprechung von Nummern zu Texten implementieren
    switch (Number(reasonNumber)) {
      case 0:
        return 'Bitte auswählen';
      case 1:
        return 'Brand';
      case 2:
        return 'Hilfeleistung';
      case 3:
        return 'Brandsicherheitsdienst';
      case 4:
        return 'Sonstiges';
      default:
        return 'Unbekannter Grund';
    }
  };

export default MainPage
